<template>
  <v-container>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="skips"
          :items-per-page="-1"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Skips</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- Search Box -->
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.skip_count`]="{ item }">
            <v-chip v-if="item.skip_count != 0" color="primary" dark>{{
              item.skip_count
            }}</v-chip>
            <v-chip v-else color="green" dark>
              {{ getSkipDuration(item) }} hours
            </v-chip>
          </template>
          <template v-slot:[`item.skip_dates`]="{ item }">
            <div v-if="item.skip_time_start">
              {{ getHumanDateAndTime(item.skip_time_start) }} -
              {{ getHumanDateAndTime(item.skip_time_end) }}
            </div>
            <div v-else>Count based Skip</div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ getHumanDateAndTime(item.created_at) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import moment from "moment";
export default {
  name: "SkipsView",
  data() {
    return {
      search: "",
      skips: [],
      headers: [
        {
          text: "Agent",
          value: "agent",
        },
        {
          text: "Reason",
          value: "skip_reason",
        },
        {
          text: "Date",
          value: "created_at",
        },
        {
          text: "Skip Count/Duration",
          value: "skip_count",
          align: "center",
        },
        {
          text: "Skip Dates",
          value: "skip_dates",
        },
        {
          text: "Author",
          value: "skip_author",
        },
      ],
    };
  },
  methods: {
    getSkips() {
      axios.get("/api/v1/skips/list").then((response) => {
        this.skips = response.data;
      });
    },
    getSkipDuration(skip) {
      const skipStart = moment(skip.skip_time_start);
      const skipEnd = moment(skip.skip_time_end);
      return skipEnd.diff(skipStart, "hours");
    },
    getHumanDateAndTime(time) {
      return moment(time).format("MMM Do YYYY, HH:mm");
    },
  },
  created() {
    this.getSkips();
  },
};
</script>

<style lang="scss" scoped></style>
